import { Tabs } from "antd";
import { useContext, useState } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { useHistory, useParams } from "react-router";
import ErrorBoundary from "components/error-boundary";
import { isProjectInIntegrationMode } from "utils/utils";
import { EUserRoleName, isGcProjectAdminRole } from "../../constants";
import ModuleSettings from "./module-settings";
import GeneralSettings from "./general-settings";
import ProjectIntegrationsTab from "./project-integrations/project-integrations-tab";
import Locations from "./locations/locations";

function ProjectSettingManu() {
  const history = useHistory();
  const { projectId, tab1Id } = useParams<{
    projectId: string;
    tab1Id: string;
  }>();
  const [tabIndex, setTabIndex] = useState<string>(tab1Id || "general");
  const { tokenContents, isFeatureFlagEnabled, projectDetails } =
    useContext(ProjectContext);
  const isLocationEnabled = isFeatureFlagEnabled(
    "LOCATION_BREAKDOWN_STRUCTURE"
  );
  const showOpc = isFeatureFlagEnabled("OPC_INTEGRATION_V1");
  const isIntegrationMode = isProjectInIntegrationMode(
    projectDetails ? projectDetails.mode : 0
  );

  const isInternalGCser =
    isGcProjectAdminRole(tokenContents?.role) ||
    tokenContents?.role === EUserRoleName[EUserRoleName.gc_foreman];

  // Workflow mode: Integrations only when OPC is enabled (schedules).
  // Integration mode: always show for submittal (+ schedule when OPC on).
  const showIntegrationsTab = isInternalGCser && (isIntegrationMode || showOpc);

  const tabItems = [
    {
      label: "General Settings",
      key: "general",
      children: <GeneralSettings isInternalGCser={isInternalGCser} />
    },
    {
      label: "Module Settings",
      key: "modules",
      children: <ModuleSettings />
    }
  ];

  if (isLocationEnabled) {
    tabItems.push({
      label: "Locations",
      key: "locations",
      children: <Locations />
    });
  }

  if (showIntegrationsTab) {
    tabItems.push({
      label: "Integrations",
      key: "integrations",
      children: (
        <ErrorBoundary>
          <ProjectIntegrationsTab />
        </ErrorBoundary>
      )
    });
  }

  const secondTabItems = [
    {
      label: "General Settings",
      key: "general",
      children: <GeneralSettings isInternalGCser={isInternalGCser} />
    }
  ];

  return (
    <div className="w-full h-full">
      <Tabs
        renderTabBar={(tabBarProps, DefaultTabBar) => (
          <div className="sticky top-0 z-20 bg-white">
            <DefaultTabBar {...tabBarProps} />
          </div>
        )}
        onChange={(activeKey) => {
          history.push(
            `/project/${projectId}/settings/${activeKey.toString()}`
          );
          setTabIndex(activeKey);
        }}
        activeKey={tabIndex}
        items={isInternalGCser ? tabItems : secondTabItems}
        destroyOnHidden
        className=""
        data-testid="index-tabs-project-setting"
      />
    </div>
  );
}
export default ProjectSettingManu;
